module.exports = __webpack_public_path__ + "static/img/summer_jianjiePic.45c750e4.png";